module.exports = __webpack_public_path__ + "img/man-torso-front.5faf9f5d.png";